import { render, staticRenderFns } from "./upload-btn.vue?vue&type=template&id=4d6ee50a&scoped=true&"
import script from "./upload-btn.js?vue&type=script&lang=js&"
export * from "./upload-btn.js?vue&type=script&lang=js&"
import style0 from "./upload-btn.scss?vue&type=style&index=0&id=4d6ee50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6ee50a",
  null
  
)

export default component.exports